import { gql } from "@apollo/client";

export default gql`
  mutation removeCustomerPaymentCard($input: removeCustomerPaymentCardInput!){
    removeCustomerPaymentCard(input: $input){
        success
        data{
            _id
            customer
            cards{
                _id
                cardAlias
                cardBankName
                lastFourDigits
                cardType
                cardAssociation
                expireMonth
                expireYear
                cvc
                locale
                status
                default
                systemTime
            }
            provider
            requiresAction
            confirmationUrl
            threeDSHtmlContent
            threeDSPaymentPageUrl
            threeDSPaymentId
            threeDSConversationId
            actionType
            createdAt
            updatedAt
        }
        code
        message
    }
}
`
